import React from 'react';
import { Dialogs, Dialog, Button } from '@leverege/ui-elements';
import { TableEditor, ColumnRendererFactory, Columns, Attributes } from '@leverege/ui-attributes';
import { UserSettingsModelEditor } from '@leverege/molten/views';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('pairing.bulkPairing.views.BulkResultsTableColumns');
const entryColumn = {
  id: 'entry',
  get Header() {
    return t('entryLine');
  },
  minWidth: 160,
  accessor: rowObj => rowObj.index + 1
};
const parentIdColumn = parentColumnName => {
  return {
    id: parentColumnName,
    Header: parentColumnName,
    minWidth: 160,
    accessor: parentColumnName
  };
};
const objectIdColumn = objectColumnName => {
  return {
    id: objectColumnName,
    Header: objectColumnName,
    minWidth: 160,
    accessor: objectColumnName
  };
};
const errorColumn = {
  id: 'error',
  get Header() {
    return t('error');
  },
  minWidth: 160,
  width: 260,
  accessor: 'message'
};
const actionColumn = overridePairing => {
  return {
    id: 'action',
    get Header() {
      return t('action');
    },
    minWidth: 160,
    accessor: 'message',
    Cell: ({
      value,
      row
    }) => {
      if (value === 'unable to add relationship') {
        return /*#__PURE__*/React.createElement(Button, {
          eventData: row.original,
          onClick: overridePairing,
          variant: "linkTable"
        }, t('actionCell'));
      }
      return '-';
    }
  };
};
const determineColumns = ({
  model,
  parentObjectType,
  unpair,
  overridePairing,
  objectColumnName,
  parentColumnName
}) => {
  const errorColumns = [entryColumn, errorColumn, parentIdColumn(parentColumnName)];
  if (!unpair) {
    errorColumns.push(objectIdColumn(objectColumnName));
  }
  errorColumns.push(actionColumn(overridePairing));
  const apiColumns = Columns.getColumnsFor(parentObjectType).map(col => col.create());
  const columns = model.columns.map(col => {
    const curr = apiColumns.find(c => c.attrName === col.attrName);
    const rnd = ColumnRendererFactory.create(curr);
    if (rnd != null) {
      const colInfo = rnd.getColumnInfo({
        clientProps: {
          columns: model.columns
        }
      });
      const attribute = Attributes.getAttribute(curr.attrName, parentObjectType);
      if (attribute) {
        colInfo.attribute = attribute;
        return colInfo;
      }
    }
    return false;
  });
  const successColumns = [entryColumn, parentIdColumn(parentColumnName)];
  if (!unpair) {
    successColumns.push(objectIdColumn(objectColumnName));
  }
  return {
    errorColumns,
    successColumns: [...successColumns, ...columns.filter(col => !!col)]
  };
};
const onEditTable = ({
  data
}) => {
  const {
    settingsPath,
    model,
    parentObjectType
  } = data;
  Dialogs.show({
    component: props => {
      const {
        show,
        onClose
      } = props;
      return /*#__PURE__*/React.createElement(Dialog, {
        show: show,
        closeOnEscape: false,
        closeOnDocumentClick: false,
        onClose: onClose
      }, /*#__PURE__*/React.createElement(UserSettingsModelEditor, props));
    },
    props: {
      editor: TableEditor,
      settingsPath,
      versionsPath: `${parentObjectType}.tableModel`,
      title: t('title'),
      modelName: t('modelName'),
      editorProps: {
        objectType: parentObjectType
      },
      value: model
    }
  });
};
export default {
  onEditTable,
  determineColumns
};